import { render, staticRenderFns } from "./CoverFull.vue?vue&type=template&id=c00c576a&"
import script from "./CoverFull.vue?vue&type=script&lang=js&"
export * from "./CoverFull.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports